<template>
  <v-dialog
    persistent=""
    v-model="dialog"
    fullscreen=""
    @click:outside="$emit('CloseModal')"
  >
    <v-card>
      <v-toolbar
        color="primary"
        :class="
          $vuetify.breakpoint.smAndDown
            ? 'white--text font-weight-bold'
            : 'headline white--text font-weight-bold'
        "
        >EQUIPMENT AVATAR<v-spacer></v-spacer>
        <v-btn color="white" x-large="" icon @click="$emit('CloseModal')"
          ><v-icon>mdi-close</v-icon></v-btn
        ></v-toolbar
      >

      <v-card-text>
        <v-img
          style="border-radius:18px"
          max-width="500"
          aspect-ratio="1"
          max-height="500"
          height="auto"
          class="mx-auto my-12 "
          :src="equipmentProfile.pic"
        ></v-img>

        <upload-photo class="my-12"></upload-photo>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import UploadPhoto from "./UploadPhoto";
import { mapState } from "vuex";
export default {
  components: {
    UploadPhoto
  },
  computed: {
    ...mapState("equipments", ["equipmentProfile"])
  },
  props: ["dialog"]
};
</script>
<style scope></style>
